export enum WorkspaceType {
  Enrollment = 'enrollment',
  Placement = 'placement',
  Retention = 'retention',
  Compliance = 'compliance',
}
